// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"489":"68dbf1f2","787":"9e9f4ffd","991":"0aaebd05"}[chunkId] + ".chunk.js";
};